// Local fallback data copied from the backend service catalog.
export const servicesData = [
  {
    "service_id": 1,
    "name": "Manicure Simples",
    "workers": [
      1,
      2
    ],
    "price": 5,
    "description": [
      "Limpeza das unhas",
      "Corte e limagem",
      "Tratamento de cutículas",
      "Hidratação"
    ],
    "duration": 15,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/0_manicure_simples.jpg"
  },
  {
    "service_id": 2,
    "name": "Manicure simples com pintura",
    "workers": [
      1,
      2
    ],
    "price": 12,
    "description": [
      "Manicure completa",
      "Aplicação de verniz tradicional",
      "Escolha de cor",
      "Acabamento brilhante"
    ],
    "duration": 30,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/1_manicure_pintura.jpg"
  },
  {
    "service_id": 3,
    "name": "Verniz Gel",
    "workers": [
      1,
      2
    ],
    "price": 15,
    "description": [
      "Manicure completa",
      "Aplicação de verniz gel",
      "Secagem rápida em lâmpada UV",
      "Duração de 2 a 3 semanas"
    ],
    "duration": 45,
    "category": "Manicure",
    "featured": true,
    "service_image": "images/manicure/2_verniz_gel.jpg"
  },
  {
    "service_id": 4,
    "name": "1ª Aplicação de Gel",
    "workers": [
      1,
      2
    ],
    "price": 27,
    "description": [
      "Preparação das unhas",
      "Aplicação de gel sobre a unha natural",
      "Escolha de cor",
      "Acabamento brilhante"
    ],
    "duration": 75,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/3_primeira_aplicacao.jpg"
  },
  {
    "service_id": 5,
    "name": "1ª Aplicação de Acrygel sobre a unha",
    "workers": [
      1,
      2
    ],
    "price": 27,
    "description": [
      "Preparação das unhas",
      "Aplicação de acrygel sobre a unha natural",
      "Escolha de cor",
      "Acabamento brilhante"
    ],
    "duration": 75,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/10_primeira_aplicacao_Acrygel.jpg"
  },
  {
    "service_id": 6,
    "name": "Manutenção de Gel",
    "workers": [
      1,
      2
    ],
    "price": 20,
    "description": [
      "Remoção parcial do gel anterior",
      "Preenchimento da área crescida",
      "Nova aplicação de cor",
      "Acabamento brilhante"
    ],
    "duration": 75,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/4_manutencao_gel.png"
  },
  {
    "service_id": 7,
    "name": "Manutenção de Acrygel",
    "workers": [
      1,
      2
    ],
    "price": 25,
    "description": [
      "Remoção parcial do acrygel anterior",
      "Preenchimento com material novo",
      "Modelagem e acabamento",
      "Aplicação de cor à escolha"
    ],
    "duration": 75,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/5_manutencao_acrygel.jpg"
  },
  {
    "service_id": 8,
    "name": "1ª Aplicação De gel com extensão",
    "workers": [
      1,
      2
    ],
    "price": 35,
    "description": [
      "Preparação das unhas",
      "Aplicação de tips ou moldes",
      "Extensão com gel",
      "Modelagem e acabamento personalizado"
    ],
    "duration": 75,
    "category": "Manicure",
    "featured": true,
    "service_image": "images/manicure/6_gel_extensao.jpg"
  },
  {
    "service_id": 9,
    "name": "1ª Aplicação De Acrygel com extensão",
    "workers": [
      1,
      2
    ],
    "price": 35,
    "description": [
      "Preparação das unhas",
      "Aplicação de tips ou moldes",
      "Extensão com acrygel",
      "Maior resistência e durabilidade"
    ],
    "duration": 75,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/7_acrygel_extensao.jpg"
  },
  {
    "service_id": 10,
    "name": "Unha partida",
    "workers": [
      1,
      2
    ],
    "price": 2,
    "description": [
      "Reparação de unha danificada",
      "Reforço com gel ou acrygel",
      "Acabamento uniforme",
      "Serviço rápido e eficiente"
    ],
    "duration": 15,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/8_unha_partida.jpg"
  },
  {
    "service_id": 11,
    "name": "Remoção Verniz gel/Gel/Acrygel",
    "workers": [
      1,
      2
    ],
    "price": 10,
    "description": [
      "Remoção segura sem danificar a unha natural",
      "Limagem e polimento",
      "Hidratação intensiva",
      "Acabamento natural"
    ],
    "duration": 15,
    "category": "Manicure",
    "featured": false,
    "service_image": "images/manicure/9_remocao.jpg"
  },
  {
    "service_id": 12,
    "name": "Epilação a Cera do Buço",
    "workers": [
      1,
      2
    ],
    "price": 3,
    "description": [
      "Remoção dos pelos do buço",
      "Técnica suave para pele sensível",
      "Cera de alta qualidade",
      "Resultado limpo e sem irritações"
    ],
    "duration": 15,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/0-depilacao-cera-buco.png"
  },
  {
    "service_id": 13,
    "name": "Epilação a Cera nas Sobrancelhas",
    "workers": [
      1,
      2
    ],
    "price": 5,
    "description": [
      "Design personalizado",
      "Técnica de precisão",
      "Remoção total de pelos indesejados",
      "Forma harmoniosa com o rosto"
    ],
    "duration": 15,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/1-depilacao-cera-sobrancelha.jpg"
  },
  {
    "service_id": 14,
    "name": "Epilação a Cera do Mento",
    "workers": [
      1,
      2
    ],
    "price": 4,
    "description": [
      "Depilação da região do queixo",
      "Cera específica para áreas pequenas",
      "Técnica rápida e eficiente",
      "Resultado duradouro"
    ],
    "duration": 15,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/2-depilacao-cera-mento.jpg"
  },
  {
    "service_id": 15,
    "name": "Epilação a Cera das Axilas",
    "workers": [
      1,
      2
    ],
    "price": 5,
    "description": [
      "Depilação completa das axilas",
      "Técnica precisa e rápida",
      "Pele macia por mais tempo",
      "Mínimo desconforto"
    ],
    "duration": 15,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/3-depilacao-cera-axilas.jpg"
  },
  {
    "service_id": 16,
    "name": "Epilação a Cera da Virilha cavada",
    "workers": [
      1,
      2
    ],
    "price": 6,
    "description": [
      "Depilação parcial da área íntima",
      "Formato adaptado à preferência",
      "Técnica delicada",
      "Produto pós-depilação para acalmar"
    ],
    "duration": 15,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/4-depilacao-cera-virilha-cavada.jpg"
  },
  {
    "service_id": 17,
    "name": "Epilação a Cera da Virilha completa",
    "workers": [
      1,
      2
    ],
    "price": 9,
    "description": [
      "Depilação total da área íntima",
      "Técnica cuidadosa para minimizar desconforto",
      "Produto calmante pós-depilação",
      "Resultado duradouro"
    ],
    "duration": 30,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/5-depilacao-cera-virilha-completa.jpg"
  },
  {
    "service_id": 18,
    "name": "Epilação a Cera dos Braços",
    "workers": [
      1,
      2
    ],
    "price": 8,
    "description": [
      "Depilação dos braços do pulso até o ombro",
      "Técnica em seções para maior conforto",
      "Remoção completa dos pelos",
      "Pele suave por semanas"
    ],
    "duration": 30,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/6-depilacao-cera-bracos-completos.jpg"
  },
  {
    "service_id": 19,
    "name": "Epilação a Cera da Meia perna",
    "workers": [
      1,
      2
    ],
    "price": 8,
    "description": [
      "Depilação do tornozelo até o joelho em ambas as pernas",
      "Ou do joelho até a coxa",
      "Técnica em faixas para eficiência",
      "Produto hidratante para finalizar"
    ],
    "duration": 30,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/7-depilacao-cera-meia-perna.jpg"
  },
  {
    "service_id": 20,
    "name": "Epilação a Cera da Perna completa",
    "workers": [
      1,
      2
    ],
    "price": 13,
    "description": [
      "Depilação das pernas do tornozelo à coxa",
      "Técnica em seções para maior conforto",
      "Remoção completa dos pelos",
      "Pele macia e hidratada"
    ],
    "duration": 30,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/8-depilacao-cera-perna-inteira.jpg"
  },
  {
    "service_id": 21,
    "name": "Epilação a Cera - Pack Corpo Completo",
    "workers": [
      1,
      2
    ],
    "price": 30,
    "description": [
      "Combo completo de depilação",
      "Preço promocional integrado",
      "Técnica otimizada para reduzir tempo",
      "Finalização com produto calmante e hidratante"
    ],
    "duration": 60,
    "category": "Epilação a Cera Mulher",
    "featured": false,
    "service_image": "images/depilacao_cera/9-depilacao-cera-perna-inteira-virilha-axila.jpg"
  },
  {
    "service_id": 22,
    "name": "Epilação a Cera do Peito/Abdómen",
    "workers": [
      1,
      2
    ],
    "price": 13,
    "description": [
      "Depilação completa do peito e abdômen",
      "Cera específica para pelos masculinos",
      "Técnica para minimizar desconforto",
      "Produto pós-depilação para acalmar"
    ],
    "duration": 30,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera_homem/0-peito-abdomen.jpg"
  },
  {
    "service_id": 23,
    "name": "Epilação a Cera das Costas",
    "workers": [
      1,
      2
    ],
    "price": 12,
    "description": [
      "Depilação completa das costas",
      "Técnica eficiente para área extensa",
      "Alcance de todas as áreas",
      "Resultado uniforme"
    ],
    "duration": 15,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera_homem/1-costas.jpg"
  },
  {
    "service_id": 24,
    "name": "Epilação a Cera dos Glúteos",
    "workers": [
      1,
      2
    ],
    "price": 6,
    "description": [
      "Depilação completa da área dos glúteos",
      "Técnica precisa e rápida",
      "Produto especial para sensibilidade",
      "Acabamento uniforme"
    ],
    "duration": 15,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera_homem/2-gluteos.png"
  },
  {
    "service_id": 25,
    "name": "Epilação a Cera da Virilha",
    "workers": [
      1,
      2
    ],
    "price": 8,
    "description": [
      "Depilação da área íntima masculina",
      "Técnica adaptada para maior conforto",
      "Produto calmante pós-depilação",
      "Resultado duradouro"
    ],
    "duration": 30,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera_homem/3-virilha.jpg"
  },
  {
    "service_id": 26,
    "name": "Epilação a Cera das Axilas",
    "workers": [
      1,
      2
    ],
    "price": 6,
    "description": [
      "Depilação completa das axilas",
      "Técnica específica para pelos grossos",
      "Remoção completa",
      "Produto antisséptico para finalizar"
    ],
    "duration": 15,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera_homem/4-axilas.jpg"
  },
  {
    "service_id": 27,
    "name": "Epilação a Cera de Meia Perna",
    "workers": [
      1,
      2
    ],
    "price": 13,
    "description": [
      "Depilação meia perna",
      "Técnica específica para pelos masculinos",
      "Trabalho em seções para maior conforto",
      "Hidratação final"
    ],
    "duration": 30,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera_homem/5-pernas.png"
  },
  {
    "service_id": 28,
    "name": "Epilação a Cera da Perna Completa",
    "workers": [
      1,
      2
    ],
    "price": 20,
    "description": [
      "Depilação completa das pernas",
      "Técnica específica para pelos masculinos",
      "Trabalho em seções para maior conforto",
      "Hidratação final"
    ],
    "duration": 30,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": null,
    "icon": "cera"
  },
  {
    "service_id": 29,
    "name": "Epilação a Cera dos Braços",
    "workers": [
      1,
      2
    ],
    "price": 10,
    "description": [
      "Depilação dos braços do pulso até o ombro",
      "Técnica para pelos mais grossos",
      "Remoção completa",
      "Produto calmante para finalizar"
    ],
    "duration": 30,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera_homem/6-bracos-completos.jpg"
  },
  {
    "service_id": 30,
    "name": "Epilação a Cera - Pack Corpo Completo Homem",
    "workers": [
      1,
      2
    ],
    "price": 45,
    "description": [
      "Combo completo de depilação para homem",
      "Inclui todas as zonas principais",
      "Preço promocional integrado",
      "Técnica otimizada para reduzir tempo",
      "Finalização com produto calmante e hidratante"
    ],
    "duration": 90,
    "category": "Epilação a Cera Homem",
    "featured": false,
    "service_image": "images/depilacao_cera/9-depilacao-cera-perna-inteira-virilha-axila.jpg"
  },
  {
    "service_id": 31,
    "name": "Epilação à Linha do Rosto completo",
    "workers": [
      1,
      2
    ],
    "price": 15,
    "description": [
      "Epilação completa do rosto",
      "Inclui sobrancelhas, buço e outras áreas",
      "Técnica delicada para pele sensível",
      "Resultado limpo e duradouro"
    ],
    "duration": 30,
    "category": "Epilação à Linha",
    "featured": false,
    "service_image": "images/depilacao_linha/0_rosto_completo.jpg"
  },
  {
    "service_id": 32,
    "name": "Epilação à Linha das Sobrancelhas",
    "workers": [
      1,
      2
    ],
    "price": 7,
    "description": [
      "Design personalizado",
      "Técnica de precisão",
      "Remoção total de pelos indesejados",
      "Forma harmoniosa com o rosto"
    ],
    "duration": 15,
    "category": "Epilação à Linha",
    "featured": false,
    "service_image": "images/depilacao_linha/1_sobrancelhas.jpg"
  },
  {
    "service_id": 33,
    "name": "Epilação à Linha do Buço",
    "workers": [
      1,
      2
    ],
    "price": 4,
    "description": [
      "Remoção dos pelos do buço",
      "Técnica suave para pele sensível",
      "Cera de alta qualidade",
      "Resultado limpo e sem irritações"
    ],
    "duration": 15,
    "category": "Epilação à Linha",
    "featured": false,
    "service_image": "images/depilacao_linha/2_buco.jpg"
  },
  {
    "service_id": 34,
    "name": "Pedicure simples",
    "workers": [
      1,
      2
    ],
    "price": 10,
    "description": [
      "Limpeza das unhas dos pés",
      "Corte e limagem",
      "Tratamento de cutículas",
      "Hidratação básica"
    ],
    "duration": 30,
    "category": "Pedicure",
    "featured": false,
    "service_image": "images/pedicure/0_pedicure_simples.jpg"
  },
  {
    "service_id": 35,
    "name": "Pedicure simples com verniz",
    "workers": [
      1,
      2
    ],
    "price": 13,
    "description": [
      "Pedicure simples completa",
      "Aplicação de verniz tradicional",
      "Escolha de cor",
      "Acabamento brilhante"
    ],
    "duration": 30,
    "category": "Pedicure",
    "featured": false,
    "service_image": "images/pedicure/1_pedicure_simples_verniz.jpg"
  },
  {
    "service_id": 36,
    "name": "Pedicure completa",
    "workers": [
      1,
      2
    ],
    "price": 17,
    "description": [
      "Banho relaxante de pés",
      "Esfoliação completa",
      "Tratamento de cutículas e calosidades",
      "Massagem hidratante"
    ],
    "duration": 45,
    "category": "Pedicure",
    "featured": false,
    "service_image": "images/pedicure/2_pedicure_completa.jpg"
  },
  {
    "service_id": 37,
    "name": "Pedicure completa com verniz",
    "workers": [
      1,
      2
    ],
    "price": 20,
    "description": [
      "Pedicure completa",
      "Aplicação de verniz tradicional",
      "Secagem completa",
      "Acabamento de longa duração"
    ],
    "duration": 60,
    "category": "Pedicure",
    "featured": false,
    "service_image": "images/pedicure/3_pedicure_completa_verniz.jpg"
  },
  {
    "service_id": 38,
    "name": "Pintura com verniz gel nos pés",
    "workers": [
      1,
      2
    ],
    "price": 15,
    "description": [
      "Aplicação de verniz gel nas unhas dos pés",
      "Secagem em lâmpada UV",
      "Durabilidade de 3 a 4 semanas",
      "Acabamento brilhante"
    ],
    "duration": 30,
    "category": "Pedicure",
    "featured": false,
    "service_image": "images/pedicure/4_pedicure_verniz_gel.png"
  },
  {
    "service_id": 39,
    "name": "Pedicure com verniz gel nos pés",
    "workers": [
      1,
      2
    ],
    "price": 25,
    "description": [
      "Pedicure completa",
      "Aplicação de verniz gel",
      "Tratamento de hidratação intensiva",
      "Máxima durabilidade"
    ],
    "duration": 60,
    "category": "Pedicure",
    "featured": false,
    "service_image": "images/pedicure/5_pedicure_verniz_gel_completo.jpg"
  },
  {
    "service_id": 40,
    "name": "Depilação a Laser - 1 zona",
    "workers": [
      1
    ],
    "price": 15,
    "description": [
      "Depilação a laser de uma área pequena",
      "Equipamento de última geração",
      "Resultados visíveis em poucas sessões",
      "Tratamento indolor e seguro"
    ],
    "duration": 15,
    "category": "Depilação a Laser",
    "featured": false,
    "service_image": null,
    "group": "Por zonas",
    "icon": "laser"
  },
  {
    "service_id": 41,
    "name": "Depilação a Laser - 2 zonas",
    "workers": [
      1
    ],
    "price": 30,
    "description": [
      "Depilação a laser de duas áreas",
      "Preço promocional combinado",
      "Tecnologia avançada",
      "Personalização para cada tipo de pele"
    ],
    "duration": 15,
    "category": "Depilação a Laser",
    "featured": false,
    "service_image": null,
    "group": "Por zonas",
    "icon": "laser"
  },
  {
    "service_id": 42,
    "name": "Depilação a Laser - 3 zonas",
    "workers": [
      1
    ],
    "price": 45,
    "description": [
      "Depilação a laser de três áreas à escolha",
      "Economia significativa no pacote",
      "Proteção personalizada",
      "Redução permanente dos pelos"
    ],
    "duration": 30,
    "category": "Depilação a Laser",
    "featured": false,
    "service_image": null,
    "group": "Por zonas",
    "icon": "laser"
  },
  {
    "service_id": 43,
    "name": "Depilação a Laser - 4 zonas",
    "workers": [
      1
    ],
    "price": 60,
    "description": [
      "Depilação a laser de quatro áreas",
      "Pacote com desconto especial",
      "Equipamento de alta potência",
      "Resultados duradouros"
    ],
    "duration": 45,
    "category": "Depilação a Laser",
    "featured": false,
    "service_image": null,
    "group": "Por zonas",
    "icon": "laser"
  },
  {
    "service_id": 44,
    "name": "Depilação a Laser - Corpo Completo Mulher (sem braços)",
    "workers": [
      1
    ],
    "price": 50,
    "description": [
      "Depilação a laser completa para mulher",
      "Não inclui braços",
      "Melhor relação custo-benefício",
      "Ajuste de potência para cada área",
      "Resultados visíveis desde a primeira sessão"
    ],
    "duration": 60,
    "category": "Depilação a Laser",
    "featured": false,
    "service_image": "images/depilacao_laser/3-4-zonas.jpg",
    "group": "Corpo completo"
  },
  {
    "service_id": 45,
    "name": "Depilação a Laser - Corpo Completo Homem (sem braços)",
    "workers": [
      1
    ],
    "price": 60,
    "description": [
      "Depilação a laser completa para homem",
      "Não inclui braços",
      "Melhor relação custo-benefício",
      "Ajuste de potência para cada área",
      "Resultados visíveis desde a primeira sessão"
    ],
    "duration": 75,
    "category": "Depilação a Laser",
    "featured": false,
    "service_image": "images/depilacao_laser/0_corpo_completo_homem.jpg",
    "group": "Corpo completo"
  },
  {
    "service_id": 46,
    "name": "Brown Lamination",
    "workers": [
      1,
      2
    ],
    "price": 25,
    "description": [
      "Lamina e fixa os pelos da sobrancelha",
      "Proporciona um efeito volumoso e estruturado",
      "Define e alinha os pelos em uma direção uniforme",
      "Realça o olhar de forma natural"
    ],
    "duration": 45,
    "category": "Sobrancelhas",
    "featured": false,
    "service_image": "images/sobrancelhas/0-sobrancelhas-laminacao.jpg"
  },
  {
    "service_id": 47,
    "name": "Henna",
    "workers": [
      1,
      2
    ],
    "price": 15,
    "description": [
      "Coloração temporária para sobrancelhas",
      "Efeito natural com duração de até 15 dias",
      "Ideal para quem quer experimentar um novo formato",
      "Design personalizado para cada tipo de rosto"
    ],
    "duration": 45,
    "category": "Sobrancelhas",
    "featured": false,
    "service_image": "images/sobrancelhas/1-sobrancelhas-henna.jpg"
  },
  {
    "service_id": 48,
    "name": "Coloração de Sobrancelhas",
    "workers": [
      1,
      2
    ],
    "price": 15,
    "description": [
      "Coloração profissional das sobrancelhas",
      "Pigmentação duradoura e resistente",
      "Cor uniforme e natural",
      "Realça o olhar",
      "Duração de várias semanas"
    ],
    "duration": 30,
    "category": "Sobrancelhas",
    "featured": false,
    "service_image": "images/sobrancelhas/3-sobrancelhas-coloracao.jpg"
  },
  {
    "service_id": 49,
    "name": "Microblading",
    "workers": [
      1
    ],
    "price": "Sob consulta",
    "description": [
      "Usa-se uma caneta com microlâminas",
      "Aplica-se pigmento na camada superficial da pele",
      "Desenha fios finos nas sobrancelhas, imitando os pelos naturais",
      "Preenche falhas nas sobrancelhas",
      "Corrige o formato",
      "Resultado natural e personalizado para cada rosto"
    ],
    "duration": 75,
    "category": "Especializados",
    "featured": false,
    "service_image": "images/sobrancelhas/2-sobrancelhas-microblading.jpg"
  },
  {
    "service_id": 50,
    "name": "1ª Aplicação de pestanas brasileiras",
    "workers": [
      1
    ],
    "price": 35,
    "description": [
      "Volume natural",
      "Cílios flexíveis e leves",
      "Aspecto mais denso e natural",
      "Duração de 3-4 semanas"
    ],
    "duration": 75,
    "category": "Pestanas",
    "featured": false,
    "service_image": "images/pestanas/0-pestanas-brasileiras.jpg"
  },
  {
    "service_id": 51,
    "name": "1ª Aplicação de pestanas Egípcia",
    "workers": [
      1
    ],
    "price": 35,
    "description": [
      "Formato alongado nas pontas externas",
      "Efeito de olhos puxados",
      "Olhar mais intenso e dramático",
      "Ideal para olhos redondos"
    ],
    "duration": 75,
    "category": "Pestanas",
    "featured": false,
    "service_image": "images/pestanas/1-pestanas-egipcias.jpg"
  },
  {
    "service_id": 52,
    "name": "1ª Aplicação de pestanas Híbridas",
    "workers": [
      1
    ],
    "price": 35,
    "description": [
      "Mistura de técnicas para volume e comprimento",
      "Combina cílios finos e mais espessos",
      "Efeito natural com pontos de destaque",
      "Adaptável a diferentes formatos de olhos"
    ],
    "duration": 75,
    "category": "Pestanas",
    "featured": false,
    "service_image": "images/pestanas/2-pestanas-hibridas.jpg"
  },
  {
    "service_id": 53,
    "name": "1ª Aplicação de pestanas de Volume Russo",
    "workers": [
      1
    ],
    "price": 35,
    "description": [
      "Técnica de volume russo para pestanas",
      "Efeito de pestanas mais cheias e volumosas",
      "Múltiplos fios finos aplicados em cada pestana natural",
      "Olhar dramático e impactante",
      "Duração de 3-4 semanas"
    ],
    "duration": 90,
    "category": "Pestanas",
    "featured": false,
    "service_image": "images/pestanas/4-pestanas-russas.jpg"
  },
  {
    "service_id": 54,
    "name": "Manutenção de Aplicação de Pestanas (3 em 3 semanas)",
    "workers": [
      1
    ],
    "price": 30,
    "description": [
      "Remoção de pestanas soltas",
      "Aplicação de novas pestanas",
      "Reposição nas áreas necessárias",
      "Mantém o efeito das extensões"
    ],
    "duration": 45,
    "category": "Pestanas",
    "featured": false,
    "service_image": "images/pestanas/3-pestanas-manutencao.jpg"
  },
  {
    "service_id": 55,
    "name": "Lifting de Pestanas",
    "workers": [
      1
    ],
    "price": 28,
    "description": [
      "Curvatura natural e duradoura das pestanas",
      "Efeito de pestanas mais longas e volumosas",
      "Duração de 6 a 8 semanas",
      "Realça o olhar sem necessidade de extensões"
    ],
    "duration": 60,
    "category": "Pestanas",
    "featured": false,
    "service_image": "images/pestanas/4-lifting-pestanas.jpg"
  },
  {
    "service_id": 56,
    "name": "Micropigmentação",
    "workers": [
      1
    ],
    "price": "Sob consulta",
    "description": [
      "Aplica-se pigmento na camada superficial da pele",
      "Realça ou corrige partes do rosto ou corpo",
      "Dura meses a alguns anos",
      "Deixa o rosto mais bonito e definido",
      "Poupa tempo na maquilhagem diária",
      "Melhora a autoestima"
    ],
    "duration": 90,
    "category": "Especializados",
    "featured": true,
    "service_image": "images/destaques/0-micropigmentacao.jpg"
  },
  {
    "service_id": 57,
    "name": "Eyeliner",
    "workers": [
      1
    ],
    "price": "Sob consulta",
    "description": [
      "Aplica-se pigmento na pele da pálpebra",
      "Realça os olhos de forma natural ou marcada",
      "Evita o uso diário de maquilhagem",
      "Dá a sensação de olhos mais definidos e expressivos",
      "Olhar bonito todos os dias, sem esforço",
      "Ideal para quem tem alergia a maquilhagem ou usa óculos",
      "Poupa tempo na rotina"
    ],
    "duration": 75,
    "category": "Especializados",
    "featured": true,
    "service_image": "images/destaques/1-eyeliner.png"
  },
  {
    "service_id": 58,
    "name": "Microagulhamento",
    "workers": [
      1
    ],
    "price": "Sob consulta",
    "description": [
      "Usa-se um aparelho com microagulhas",
      "Rejuvenesce a pele",
      "Reduz rugas e linhas finas",
      "Fecha os poros dilatados",
      "Melhora cicatrizes de acne e estrias",
      "Uniformiza o tom da pele e clareia manchas",
      "Normalmente são necessárias 3 a 6 sessões",
      "O intervalo entre sessões é de 4 a 6 semanas",
      "Pele mais jovem, firme e saudável",
      "Ajuda a tratar imperfeições e sinais do tempo"
    ],
    "duration": 45,
    "category": "Especializados",
    "featured": true,
    "service_image": "images/destaques/2-microagulhamento.jpg"
  },
  {
    "service_id": 59,
    "name": "Micropigmentação Labial",
    "workers": [
      1
    ],
    "price": "Sob consulta",
    "description": [
      "Aplica-se pigmento na pele dos lábios",
      "Dá cor, forma e definição à boca",
      "Lábios com mais cor e forma natural",
      "Dispensa o uso de batom no dia a dia",
      "Aumenta a autoestima e sensação de bem-estar"
    ],
    "duration": 90,
    "category": "Especializados",
    "featured": true,
    "service_image": "images/destaques/3-micropigmentacao-labial.jpg"
  },
  {
    "service_id": 61,
    "name": "Brushing",
    "workers": [
      1
    ],
    "price": 12,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Serviços",
    "featured": false,
    "service_image": "images/cabeleireiro/cabeleireiro.jpg",
    "prices_by_length": {
      "curto": 12,
      "medio": 15,
      "longo": 18,
      "extra_longo": 20
    },
    "duration": 45
  },
  {
    "service_id": 62,
    "name": "Coloração",
    "workers": [
      1
    ],
    "price": 25,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Serviços",
    "featured": false,
    "service_image": "images/cabeleireiro/cabeleireiro.jpg",
    "prices_by_length": {
      "curto": 25,
      "medio": 30,
      "longo": 40,
      "extra_longo": "Sob consulta"
    },
    "duration": 90
  },
  {
    "service_id": 63,
    "name": "Madeixas",
    "workers": [
      1
    ],
    "price": 70,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Serviços",
    "featured": false,
    "service_image": "images/cabeleireiro/cabeleireiro.jpg",
    "prices_by_length": {
      "curto": 70,
      "medio": 100,
      "longo": 120,
      "extra_longo": "Sob consulta"
    },
    "duration": 120
  },
  {
    "service_id": 64,
    "name": "Balayage",
    "workers": [
      1
    ],
    "price": 100,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Serviços",
    "featured": false,
    "service_image": "images/cabeleireiro/cabeleireiro.jpg",
    "prices_by_length": {
      "curto": 100,
      "medio": 120,
      "longo": 140,
      "extra_longo": "Sob consulta"
    },
    "duration": 150
  },
  {
    "service_id": 65,
    "name": "Alisamento",
    "workers": [
      1
    ],
    "price": 90,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Serviços",
    "featured": false,
    "service_image": "images/cabeleireiro/cabeleireiro.jpg",
    "price_from": true,
    "duration": 180
  },
  {
    "service_id": 66,
    "name": "Botox capilar",
    "workers": [
      1
    ],
    "price": 50,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Serviços",
    "featured": false,
    "service_image": null,
    "price_from": true,
    "icon": "brilho",
    "duration": 120
  },
  {
    "service_id": 67,
    "name": "Corte senhora",
    "workers": [
      1
    ],
    "price": 15,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Cortes",
    "featured": false,
    "service_image": null,
    "icon": "tesoura",
    "duration": 45
  },
  {
    "service_id": 68,
    "name": "Corte homem",
    "workers": [
      1
    ],
    "price": 12,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Cortes",
    "featured": false,
    "service_image": null,
    "icon": "tesoura",
    "duration": 30
  },
  {
    "service_id": 69,
    "name": "Corte criança (até 8 anos)",
    "workers": [
      1
    ],
    "price": 10,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Cortes",
    "featured": false,
    "service_image": null,
    "icon": "tesoura",
    "duration": 30
  },
  {
    "service_id": 70,
    "name": "Franja",
    "workers": [
      1
    ],
    "price": 3,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Cortes",
    "featured": false,
    "service_image": null,
    "icon": "tesoura",
    "duration": 15
  },
  {
    "service_id": 71,
    "name": "Barba",
    "workers": [
      1
    ],
    "price": 8,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Cortes",
    "featured": false,
    "service_image": null,
    "icon": "tesoura",
    "duration": 15
  },
  {
    "service_id": 72,
    "name": "Shampoo específico",
    "workers": [
      1
    ],
    "price": 2.5,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Aplicação de produtos específicos",
    "featured": false,
    "service_image": null,
    "icon": "gota"
  },
  {
    "service_id": 73,
    "name": "Espumas",
    "workers": [
      1
    ],
    "price": 2.5,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Aplicação de produtos específicos",
    "featured": false,
    "service_image": null,
    "icon": "espuma"
  },
  {
    "service_id": 74,
    "name": "Máscaras",
    "workers": [
      1
    ],
    "price": 4,
    "description": [],
    "category": "Cabeleireiro",
    "group": "Aplicação de produtos específicos",
    "featured": false,
    "service_image": null,
    "icon": "mascara"
  }
];

export default servicesData;
